module.exports = __webpack_public_path__ + "img/SI.7fc4e51c.png";